import { useState, useImperativeHandle, forwardRef, useRef, React, useEffect } from 'react';
import styled from 'styled-components';

const PointInput = forwardRef((props, ref) => {
	const { className, placeholder, type, disabled, width, changeFn, unit } = props;
	const [value, setValue] = useState(0);
	const [changed, setChanged] = useState(false);
	const [clickCount, setClickCount] = useState(0);

	const inputRef = useRef();

	useImperativeHandle(ref, () => ({
		setValue: (val) => {
			setValue(val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','));
			setChanged(true);
		},
		getValue: () => {
			if (value === '') return 0;
			else return parseInt(value.toString().replaceAll(',', ''));
		}
	}));

	useEffect(() => {
		changeFn();
	}, [value])

	function handleClick(e) {
		inputRef.current.style.borderColor = '#FF8B48';
	}

	function handleChange(e) {
		const curValue = e.target.value;
		const newValue = curValue.replace(/[^0-9]/g, '');
		const finalValue = newValue.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
		
		setValue(finalValue);
	}

	function handleFocus(e) {
	}

	function handleBlur(e) {
		setClickCount(clickCount + 1);
		inputRef.current.style.borderColor = '#B2B2B2';
	}

	return (
    <TopLevelWrapper>
      <Input
        ref={inputRef}
        disabled={disabled}
        width={width}
        clickCount={clickCount}
        type={type}
        placeholder={placeholder}
        value={value || ""}
        className={`${className} ${changed ? "changed" : ""}`}
        onClick={handleClick}
        onChange={handleChange}
        onFocus={handleFocus}
        onBlur={handleBlur} />
        <Text>{unit}</Text>
    </TopLevelWrapper>
  )
});

export default PointInput;

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

	margin-top: 8px;
`;

const Input = styled.input`
	font-family: NotoSansKR-Regular;
	font-size: 14px;
	line-height: 20px;

  width: ${props => props.width}px;
	height: 30px;

	padding: 0 8px;

	outline: none;
	border: 1px solid #B2B2B2;
	border-radius: 5px;
	color: #000000;

  background-color: ${props => props.disabled ? '#ECECEC' : '#FFFFFF'};

	::placeholder {
		color: #CBCBCB;
	}
	
  transition: all 0.3s ease-in-out;
`;

const Text = styled.p`
  font-family: Poppins-Regular;
  font-size: 12px;

  color: #000000;

  margin: 0px 0px 0px 5px;

  min-width: 11px;
`;